'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./node_modules/decisiv-domain-utils/node_modules/react/react.js
// module id = 706
// module chunks = 2